/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectProgressCommand } from '../../models/delete-project-progress-command';
import { DeleteProjectProgressCommandResult } from '../../models/delete-project-progress-command-result';

export interface ApiProjectProgressDeleteProjectProgressDelete$Plain$Params {
      body?: DeleteProjectProgressCommand
}

export function apiProjectProgressDeleteProjectProgressDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectProgressDeleteProjectProgressDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectProgressDeleteProjectProgressDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectProgressCommandResult>;
    })
  );
}

apiProjectProgressDeleteProjectProgressDelete$Plain.PATH = '/api/ProjectProgress/DeleteProjectProgress';
